var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { default as Container } from "react-bootstrap/Container";
import { styleBlock } from "../styleBlock";
export default class Layout extends React.PureComponent {
    render() {
        const _a = this.props, { ref, className, children } = _a, props = __rest(_a, ["ref", "className", "children"]);
        const classNames = styleBlock("layout");
        return (React.createElement(Container, Object.assign({ className: classNames.mix(className).toString() }, props), children));
    }
}
//# sourceMappingURL=index.js.map